const initState = {
  treeData: [
    {
      id: 1,
      name: "Contacts",
      children: []
    }
  ],

  treeDepth: 0,

  contacts: [
    {
      id: 1,
      company: "Rapid Precision Mfg.",
      title: "Quality Engineer",
      firstName: "Dongyob",
      lastName: "Lee",
      officePh: "",
      ext: "",
      cell: "669-294-0910",
      email: "dyl4810@gmail.com"
    },
    {
      id: 2,
      company: "Facebook",
      title: "Frontend Developer",
      firstName: "Edward",
      lastName: "Simmons",
      officePh: "408-516-4662",
      ext: "003",
      cell: "669-252-4251",
      email: "edwardsimmons@gmail.com"
    },
    {
      id: 3,
      company: "Amazon",
      title: "Data Scientist",
      firstName: "Harry",
      lastName: "Davis",
      officePh: "",
      ext: "",
      cell: "408-344-2110",
      email: "harrydavis0@gmail.com"
    },
    {
      id: 4,
      company: "Google",
      title: "Googler",
      firstName: "Katherine",
      lastName: "Jones",
      officePh: "408-963-7156",
      ext: "846",
      cell: "408-828-0550",
      email: "katherinejones0@gmail.com"
    },
    {
      id: 5,
      company: "Alibaba",
      title: "Scammer",
      firstName: "Eric",
      lastName: "Brown",
      officePh: "510-663-5552",
      ext: "462",
      cell: "408-644-0110",
      email: "ericbrown@gmail.com"
    }
  ],
  contactsKeyNames: [
    {
      id: "ID",
      company: "Company",
      title: "Title",
      firstName: "First Name",
      lastName: "Last Name",
      officePh: "Office",
      ext: "Ext",
      cell: "Cell",
      email: "Email"
    }
  ],
  newcontacts: []
};
const rootReducer = (state = initState, action) => {
  switch(action.type){

    case 'SORT_BY_FIELD':
      let compare = (a,b) =>{
        let aa = a[action.headerKeyActive]
        let bb = b[action.headerKeyActive]
        if(typeof(a[action.headerKeyActive])==='string'){
          aa = aa.toUpperCase();
          bb = bb.toUpperCase();
        }        
        if(action.isDown){
          return((aa>bb)?1:-1)      
        }
        else{
          return((aa<bb)?1:-1)   
        }        
      }
      const newcontacts = state.newcontacts.sort((a,b)=>compare(a,b));
      return Object.assign({}, state, {newcontacts});

    case 'FILTER_DATA':
      let dataToFilter;
      if(action.removeFilter){
        dataToFilter = state[action.dataName]
      }
      else{
        dataToFilter = state['new'+action.dataName]
      }      
      let keyNames = state[action.dataName + 'KeyNames'] 
      
      for(let i=0; i <= action.filter.length - 1; i++){
        let fieldValue = action.filter[i].field;
        let field = Object.keys(keyNames[0]).find(key => keyNames[0][key] === fieldValue)
        let condition = action.filter[i].condition;
        let input = action.filter[i].input.toLowerCase();

        if(condition === 'Contains'){
          dataToFilter = dataToFilter.filter(item => item[field].toString().toLowerCase().includes(input))          
        }        
        else if(condition === 'Not Contain'){
          dataToFilter = dataToFilter.filter(item => !item[field].toString().toLowerCase().includes(input));
        }
        else if(condition === 'Is Empty'){
          dataToFilter = dataToFilter.filter(item => !item[field]);
        }
        else if(condition === 'Is Not Empty'){
          dataToFilter = dataToFilter.filter(item => item[field]);
        }
      }
      return Object.assign({}, state, {newcontacts: dataToFilter});

    case 'DUPLICATE_DATA':
      Object.assign(state.newcontacts, state.contacts);
      return state

    case 'EDIT_DATA':      
      let newData = state
      let keysArray = Object.keys(state[action.dataName+'KeyNames'][0])      
      let index = newData[action.dataName].findIndex(obj => obj.id === action.changedDataObj.id)
      let index2 = newData['new' + action.dataName].findIndex(obj => obj.id === action.changedDataObj.id)
      
      keysArray.forEach(key =>{
        console.log(action.changedDataObj[key])
        newData[action.dataName][index][key] = action.changedDataObj[key]
        newData['new' + action.dataName][index2][key] = action.changedDataObj[key]
      })      
      return Object.assign({}, newData)      
    
    case 'DELETE_DATA':
      let newData2 = state
      newData2['new'+ action.dataName] = newData2['new'+ action.dataName].filter(obj => obj.id !== action.objID)
      newData2[action.dataName]= newData2[action.dataName].filter(obj => obj.id !== action.objID)
      return Object.assign({}, newData2)
    
    case 'ADD_DATA':
      let newData3 = state
      let keys = Object.keys(newData3[action.dataName + 'KeyNames'][0])
      let newID = 0;
      let newObj = {};
      keys.forEach(key => {
        if(key !== 'id'){
          newObj[key] = null
        }         
      })
      newData3[action.dataName].forEach(obj => {
        if(obj.id > newID){
          newID = obj.id
        }
      })
      newObj.id = newID + 1

      newData3[action.dataName] = [...newData3[action.dataName], newObj]
      newData3['new'+action.dataName] = [newObj, ...newData3['new'+action.dataName]]
      
      console.log(newData3[action.dataName])
      return Object.assign({},newData3)  
      
    default:
      return state;
  }   
};

export default rootReducer;
